<template>
    <v-card height="82vh" color="#f9f8ff">
        <v-card-title>
            <div class="stadistic-title">
                <span>RESUMEN</span>
            </div>
        </v-card-title>
        <v-card-text>
            <div class="stadistic-item">
                <span class="stadistic stadistic-item-title">Pedidos despachados</span>
                <span class="stadistic stadistic-item-number">
                    {{ stadistic.orders_dispatched }}               
                    <sup class="stadistic-badge-sup incremento">+10</sup>
                </span>
            </div>
            <div class="stadistic-item">
                <span class="stadistic stadistic-item-title">Bidones repartidos</span>
                <span class="stadistic stadistic-item-number">
                    {{ stadistic.drums_distributed }}
                    <sup class="stadistic-badge-sup incremento">+8%</sup>
                </span>
            </div>
            <div class="stadistic-item">
                <span class="stadistic stadistic-item-title">Bidones vacios repartidos</span>
                <span class="stadistic stadistic-item-number">
                    {{ stadistic.empty_drums_distributed }}
                    <sup class="stadistic-badge-sup decremento">-11%</sup>
                </span>
            </div>
            <div class="stadistic-item">
                <span class="stadistic stadistic-item-title">Nro de recargas</span>
                <span class="stadistic stadistic-item-number">
                    {{ stadistic.number_refills }}
                    <sup class="stadistic-badge-sup decremento">-11%</sup>
                </span>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'MobilityStadistic',
    props: ['stadistic'],
}
</script>

<style>

</style>